<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новый регион',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новый регион',
			items: [],
            trackBy: 'id',

			name: null,
			utc: null,

			country: null,
			countries_options: [],
			initCountries: [],


		}
	},
    
	watch: {
	    initCountries: {
            immediate: true,
            handler(values) {
                this.country = this.countries_options.filter(x => values.includes(x[this.trackBy]));
                this.country = this.country[0];
            }
        },

	},

	computed: {
	    countries_list_data(){
            return this.$store.getters['countries/GET_COUNTRIES_LIST_DATA'];
        },
	    item(){
            return this.$store.getters['regions/GET_REGIONS_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {

        this.item_uuid = this.$route.params.uuid ? this.$route.params.uuid : '';

        await this.$store.dispatch('regions/FETCH_REGIONS_LIST', {});
        this._options = this._list_data;

        await this.$store.dispatch('countries/FETCH_COUNTRIES_LIST', {});
        this.countries_options = this.countries_list_data;


        if(this.item_uuid !== ''){
    
            this.title = 'Редактирование региона';
            document.title = 'Редактирование региона' + ' | ' + appConfig.title;
    
            await this.$store.dispatch('regions/FETCH_REGIONS_ITEM', {'uuid': this.item_uuid});


            this.country = this.item.country_id ? this.item.country_id : null;
            if (this.country !== null) {
                this.initCountries = [this.country];
            }
            this.name = this.item.name ? this.item.name : null;
            this.utc = this.item.utc ? this.item.utc : null;
        }
	},

	methods: {
        async saveItem(){

        let data_send = {
            'country_id': this.country && this.country.id ? this.country.id : null,
            'name': this.name,
            'utc': this.utc,

        };
    
        let result = '';
    
        if(this.item_uuid === ''){
            result = await this.$store.dispatch('regions/FETCH_REGIONS_CREATE', data_send);
        } else {
            data_send.uuid = this.item_uuid;
            result = await this.$store.dispatch('regions/FETCH_REGIONS_UPDATE', data_send);
        }
    
        if(result === false){
            alert('Возникла ошибка');
        } else {
            this.$router.push({ name: 'Regions'});
        }
    }
	}

}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <b-form-group
                                    label="Страна"
                                    label-for="country"
                                >
                                    <multiselect
                                        id="country"
                                        v-model="country"
                                        :options="countries_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                        :track-by="trackBy"
                                    ></multiselect>
                                </b-form-group>

                                <b-form-group
                                    label="Название региона"
                                    label-for="name"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="name"
                                        placeholder=""
                                    ></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="Разница во времени UTC"
                                    label-for="utc"
                                >
                                    <b-form-input
                                        id="utc"
                                        v-model="utc"
                                        placeholder=""
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
